import {
  CampaignCreateResponse,
  GetCampaignRequest,
  GetCampaignResponse,
  ListCampaignResponse,
  RunCampaignRequest,
  TCampaignCreate,
  TCampaignUpdate,
} from "@/types/campaignTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import platformAuthConfig from "./platformConfig";

export type TagTypes = "Campaigns" | "Campaign";

const campaignApi = createApi({
  reducerPath: "campaignApi",
  ...platformAuthConfig(),
  tagTypes: ["Campaigns", "Campaign"],
  endpoints: (builder) => ({
    createCampaign: builder.mutation<CampaignCreateResponse, TCampaignCreate>({
      query: (config): FetchArgs => ({
        url: `/organizations/${config.org_id}/campaigns/create`,
        method: "POST",
        body: config,
      }),
      invalidatesTags: ["Campaigns"],
    }),
    getCampaigns: builder.query<ListCampaignResponse[], string>({
      query: (org_id): FetchArgs => ({
        url: `/organizations/${org_id}/campaigns/list_campaigns`,
        method: "GET",
      }),
      providesTags: ["Campaigns"],
    }),
    getCampaign: builder.query<GetCampaignResponse, GetCampaignRequest>({
      query: (config): FetchArgs => ({
        url: `/organizations/${config.org_id}/campaigns/${config.campaign_id}/details`,
        method: "GET",
      }),
      providesTags: ["Campaign"],
    }),
    deleteCampaign: builder.mutation<void, GetCampaignRequest>({
      query: (config): FetchArgs => ({
        url: `/organizations/${config.org_id}/campaigns/${config.campaign_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Campaigns"],
    }),
    updateCampaign: builder.mutation<CampaignCreateResponse, TCampaignUpdate>({
      query: (config): FetchArgs => ({
        url: `/organizations/${config.org_id}/campaigns/${config.campaign_id}`,
        method: "PUT",
        body: config,
      }),
      invalidatesTags: ["Campaign", "Campaigns"],
    }),

    runCampaign: builder.mutation<void, RunCampaignRequest>({
      query: (config): FetchArgs => ({
        url: `/organizations/${config.org_id}/campaigns/${config.campaign_id}/activate`,
        method: "PUT",
      }),
      invalidatesTags: ["Campaign", "Campaigns"],
    }),
  }),
});

export const {
  useCreateCampaignMutation,
  useGetCampaignsQuery,
  useGetCampaignQuery,
  useDeleteCampaignMutation,
  useUpdateCampaignMutation,
  useRunCampaignMutation,
} = campaignApi;

export default campaignApi;
